import React from "react";
import { Box, Typography, Button } from "@mui/material";

const StudentTopBar = ({ name, onLogout }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 4,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(8px)",
        borderRadius: 3,
        px: 3,
        py: 2,
        boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
      }}
    >
      <Typography variant="h4" fontWeight={600}>
        Welcome, {name}
      </Typography>

      <Button
        variant="contained"
        onClick={onLogout}
        sx={{
          borderRadius: "25px",
          px: 3,
          py: 1,
          fontWeight: 600,
          textTransform: "none",
        }}
      >
        Log Out
      </Button>
    </Box>
  );
};

export default StudentTopBar;
